export const GET_SEARCH_FILTERS_ARTWORKS = 'GET_SEARCH_FILTERS_ARTWORKS';

export function getSearchFiltersArtworks(museum_id = '', subrequest) {
  return {
    type: GET_SEARCH_FILTERS_ARTWORKS,
    subrequest: subrequest,
    request: {
      op: 'get',
      path: `${museum_id}/@search-filters-artworks`,
    },
  };
}
